export class StringUtils {
  static padWithBlankSpace(s: string, limit: number): string {
    let result = s;
    for (let i = 0; i < limit; i++) {
      result += ' ';
    }
    return result;
  }
}
